import GuestIdentifiedPopup from './GuestIdentifiedPopup';

export default GuestIdentifiedPopup;
